export const timeSeriesDataSession = (session) => {
    return session.siteWiseTimeSeriesModule;
};
export const assetSession = (session) => {
    const assetSession = session.siteWiseAssetModule.startSession();
    session.attachDataModuleSession(assetSession);
    return assetSession;
};
export const alarmsSession = (session) => {
    return session.siteWiseAlarmModule;
};
